import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ScrollSync } from 'react-scroll-sync';
import Columns from './Columns';
import Rows from './Rows';
import { Pagination } from '../Pagination';
import { Skeleton } from '../Skeleton';
import styles from '@dtsl/css-data-table/dist/index.module.css';
import '@dtsl/css-utilities/dist/common-showcase/index.css';
function DataTable(props) {
  const {
    rows = [],
    columns = [],
    isLoading = false,
    onRowSelect = () => {},
    onHeaderSelect = () => {},
    rowRenderer = null,
    totalResults = 0,
    stickyColumn = false,
    stickyHeader = true,
    noRowRenderer = () => /*#__PURE__*/React.createElement("div", null, "No data to show"),
    selectedRows = [],
    showPagination = false,
    checkboxSelection = false,
    paginationMetaData = {},
    onColumnItemSelect = () => {},
    leftActionRenderer = () => {},
    rightActionRenderer = () => {},
    dataTableBodyClass = '',
    noOfSkeletonRows = 6,
    backdropColor = 'var(--brand-white, hsla(0, 0%, 100%, 1))',
    selectAllIdentifier
  } = props;
  const RowsToRender = /*#__PURE__*/React.createElement(Rows, {
    rows: rows,
    columns: columns,
    isLoading: isLoading,
    rowRenderer: rowRenderer,
    onRowSelect: onRowSelect,
    selectedRows: selectedRows,
    noRowRenderer: noRowRenderer,
    showPagination: showPagination,
    checkboxSelection: checkboxSelection,
    dataTableBodyClass: dataTableBodyClass,
    noOfSkeletonRows: noOfSkeletonRows
  });
  const backdropClasses = classNames({
    [styles['sib-table-backdrop']]: true,
    [styles['sib-data-table--sticky-header']]: stickyHeader
  });
  const stickClass = stickyColumn ? checkboxSelection ? [styles['column-sticky-with-checkbox']] : [styles['column-sticky']] : '';
  const checkboxClass = checkboxSelection ? [styles['sib-data-table-with-checkbox']] : '';
  const dataTableClasses = classNames({
    [styles['sib-data-table']]: true,
    [checkboxClass]: !!checkboxClass,
    [stickClass]: !!stickClass
  });
  return /*#__PURE__*/React.createElement(ScrollSync, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-data-table-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: backdropClasses,
    style: {
      background: backdropColor
    }
  }), /*#__PURE__*/React.createElement("table", {
    className: dataTableClasses
  }, /*#__PURE__*/React.createElement(Columns, {
    rows: rows,
    columns: columns,
    isLoading: isLoading,
    selectedRows: selectedRows,
    onHeaderSelect: onHeaderSelect,
    totalResults: totalResults,
    checkboxSelection: checkboxSelection,
    onColumnItemSelect: onColumnItemSelect,
    leftActionRenderer: leftActionRenderer,
    rightActionRenderer: rightActionRenderer,
    stickyHeader: stickyHeader,
    backdropColor: backdropColor,
    selectAllIdentifier: selectAllIdentifier
  }), RowsToRender, showPagination ? /*#__PURE__*/React.createElement("tfoot", {
    className: styles['sib-data-table__footer']
  }, /*#__PURE__*/React.createElement("tr", null, !isLoading ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Pagination, paginationMetaData)) : /*#__PURE__*/React.createElement("td", {
    className: styles['sib-skeleton-loading-footer']
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 32,
    width: 500,
    style: {
      borderRadius: '8px'
    }
  })))) : null))));
}
DataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  onHeaderSelect: PropTypes.func,
  isLoading: PropTypes.bool,
  showPagination: PropTypes.bool,
  paginationMetaData: PropTypes.object,
  checkboxSelection: PropTypes.bool,
  stickyColumn: PropTypes.bool,
  stickyHeader: PropTypes.bool,
  rowRenderer: PropTypes.func,
  onRowSelect: PropTypes.func,
  noRowRenderer: PropTypes.func,
  onColumnItemSelect: PropTypes.func,
  selectedRows: PropTypes.array,
  totalResults: PropTypes.number,
  leftActionRenderer: PropTypes.func,
  rightActionRenderer: PropTypes.func,
  dataTableBodyClass: PropTypes.string,
  noOfSkeletonRows: PropTypes.number,
  backdropColor: PropTypes.string,
  selectAllIdentifier: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default DataTable;